import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var Typography = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, customisedCls = props.prefixCls, otherProps = __rest(props, ["className", "children", "prefixCls"]);
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('typography', configContext.prefixCls, customisedCls);
    var cls = classNames(className, prefixCls);
    return (React.createElement("div", __assign({ ref: ref, className: cls }, otherProps), children));
});
Typography.displayName = 'Typography';
export default Typography;
//# sourceMappingURL=typography.js.map